// extracted by mini-css-extract-plugin
export default {"icon":"status_icon__pIje3","icon--completed":"status_icon--completed__dCMD2","icon--past-due":"status_icon--past-due__Mr0uh","icon--validated":"status_icon--validated__j18OJ"};